import React from "react";
import { Navigate } from "react-router-dom";
export const Redirect = ({ pathname, withSearch }) => {
  return (
    <Navigate 
      to={{ pathname, search: withSearch ? window.location.search : "" }} 
      replace // Optional: `replace` makes the navigation replace the current entry in the history stack
    />
  );
};